import React, {useState} from "react";

import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserBasicInformation from "./UserBasicInformation";
import UserBanAccess from "./UserBanAccess";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";

export default function UserInformation() {
    const {id: userId} = useParams()
    const {state: location} = useLocation()
    const [fullName, setFullName] = useState("")

    useEffect(() => {
        if (location && location.fullName) {
            setFullName(location.fullName)
        }
    }, [location]);


    const navigate = useNavigate()
    const [value, setValue] = useState(UserInformationTabTypes.BasicInfo.id);

    function handleChangeTabMenu(event, newValue) {
        setValue(newValue)
    }


    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.UsersList.name,
                            RouteHelper.UsersList.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            fullName,
                            ""
                        )
                    ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>
            <UserBasicInformation setFullName={setFullName} userId={userId} updatePageTitle={name => {
                setFullName(name)
            }}/>

            {/*<TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                     className={css`
                       border-color: var(--header-border-bottom-color) !important;
                       margin-top: 24px;
                     `}>
                    <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                        <Tab
                            label={UserInformationTabTypes.BasicInfo.title}
                            value={UserInformationTabTypes.BasicInfo.id}
                        />
                        <Tab
                            label={UserInformationTabTypes.UserBanAccess.title}
                            value={UserInformationTabTypes.UserBanAccess.id}
                        />
                    </TabList>
                </Box>
                <TabPanel value={UserInformationTabTypes.BasicInfo.id}>
                    <UserBasicInformation setFullName={setFullName} userId={userId}/>
                </TabPanel>
                <TabPanel value={UserInformationTabTypes.UserBanAccess.id}>
                    <UserBanAccess userId={userId}/>
                </TabPanel>

            </TabContext>*/}

        </RaikoBaseContainer>
    )
}
export const GenderDeterminationSelection = {
    MALE: {
        name: "مرد",
        key: "MALE"
    },
    FEMALE: {
        name: "زن",
        key: "FEMALE"
    },
}
export const UserInformationTabTypes = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
    UserBanAccess: {
        id: "user-ban-access",
        title: "دسترسی"
    }
}